import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { ApiError } from "@/interfaces/api/api-error";
import {
  AudiencesApiResponse,
  CountriesApiResponse,
  InsightsApiResponse,
  VariablesApiResponse,
} from "@/interfaces/api";

export const callExternalApi = async (options: {
  config: AxiosRequestConfig;
}): Promise<
  | AudiencesApiResponse
  | CountriesApiResponse
  | VariablesApiResponse
  | InsightsApiResponse
> => {
  try {
    const response: AxiosResponse = await axios(options.config);
    const { data } = response;

    return {
      data,
      error: null,
    };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;

      const { response } = axiosError;

      let message = "http request failed";

      if (response && response.statusText) {
        message = response.statusText;
      }

      if (axiosError.message) {
        message = axiosError.message;
      }

      if (response && response.data && (response.data as ApiError).message) {
        message = (response.data as ApiError).message;
      }

      return {
        data: null,
        error: {
          message,
        },
      };
    }

    return {
      data: null,
      error: {
        message: (error as Error).message,
      },
    };
  }
};
